import email from "../../assets/icone-email.svg";
import insta from "../../assets/icone-insta.svg";
import face from "../../assets/icone-facebook.svg";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import PrivacidadeModal from "../Modal/PrivacidadeModal/PrivacidadeModal.jsx";
import TermosModal from "../Modal/TermosModal/TermosModal.jsx";

export default function Footer() {
  const { t } = useTranslation();
  const [showPrivacidadeModal, setShowPrivacidadeModal] = useState(false);
  const [showTermosModal, setShowTermosModal] = useState(false);

  return (
    <footer>
      <section id="footer">
        <hr />
        <div className="footer-container">
          <div className="footer-links">
            <h3>{t("footer.contato")}</h3>
            <div className="footer-icons">
              <a
                href="mailto:valter.neto@revalbrasil.com.br?subject=Contato%20pelo%20GranCaju&body=Ol%C3%A1%20Valter,"
                target="_blank"
                rel="noreferrer"
              >
                <p>Email</p>
                <img src={email} alt="Ícone Autoral do Email" />
              </a>
              <a
                href="https://www.instagram.com/valter_ribas_neto/?utm_source=ig_web_button_share_sheet"
                target="_blank"
                rel="noreferrer"
              >
                <p>Instagram</p>
                <img src={insta} alt="Ícone Autoral do Instagram" />
              </a>
              <a
                href="https://web.facebook.com/valter.ribasneto?rdid=PxBK8WPY2Gk6qiWq&share_url=https%3A%2F%2Fweb.facebook.com%2Fshare%2F1ABuUKHPXK%2F%3F_rdc%3D1%26_rdr#"
                target="_blank"
                rel="noreferrer"
              >
                <p>Facebook</p>
                <img src={face} alt="Ícone Autoral do Facebook" />
              </a>
            </div>
          </div>
          <div className="footer-texto">
            <p>{t("footer.p1")}</p>
            <p>{t("footer.p2")}</p>
            <p>{t("footer.p3")}</p>
          </div>
        </div>
      </section>
      <div className="direitos">
        <p className="autoral">{t("footer.direitos.autoral")}</p>
        <button
          className="privacidade"
          onClick={() => setShowPrivacidadeModal(true)}
        >
          {t("footer.direitos.privacidade")}
        </button>
        <button className="termos" onClick={() => setShowTermosModal(true)}>
          {t("footer.direitos.termos")}
        </button>
      </div>
      <PrivacidadeModal
        isOpen={showPrivacidadeModal}
        onClose={() => setShowPrivacidadeModal(false)}
      />
      <TermosModal
        isOpen={showTermosModal}
        onClose={() => setShowTermosModal(false)}
      />
    </footer>
  );
}
